//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheDetails from '@/components/arbitrator/Trade/Details.vue';
import User from '@/components/arbitrator/Trade/User.vue';
import Arbitrator from '@/components/arbitrator/Trade/Arbitrator.vue';

export default {
  components: {
    TheDetails,
    User,
    Arbitrator,
  },

  props: {
    trade: { type: Object, default: () => ({}) },
    loader: { type: Boolean, default: false },
    hasArbitratorData: { type: Boolean, default: false },
  },

  data() {
    return {
      tab: null,
    };
  },

  computed: {
    cryptoBuyer() {
      return this.$props.trade?.cryptoBuyer;
    },

    cryptoSeller() {
      return this.$props.trade?.cryptoSeller;
    },

    arbitratorHistory() {
      return this.$props.trade?.arbitratorJoinHistory;
    },

    isBuyerInitial() {
      return this.$props.trade?.cryptoBuyer?.username === this.$props.trade?.initialSideUsername;
    },

    isSellerInitial() {
      return this.$props.trade?.cryptoSeller?.username === this.$props.trade?.initialSideUsername;
    },
  },
};
